import React, { useState } from 'react';
import CurrencyInput from '../../../../../components/SafeCurrencyInput/SafeCurrencyInput.js';
import { Label, Input, FormFeedback, Table, Button } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaAsyncSeeker2 from "../../../../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker.js"
import { formatCurrency } from '../../../../../functions/functions';
import api from "../../../../../api";

const initialInputs = {
  personal_nombre: null,
  personal_id: null,
  porcentaje: 0,
  importe: 0,
  errors: {}
}

const redImportes = (accumulator, currentValue) => (accumulator + currentValue.monto);

const trunc = (n) => {
  let t = n.toString();
  let regex = /(\d*.\d{0,2})/;
  return parseFloat(t.match(regex)[0]);
}

const parsearAFloat = (m = "0") => parseFloat(String(m).replace(/[.]/g, '').replace(',', '.'));

const TableEjecutores = (props) => {
  
  const [inputs, setInputs] = useState({...initialInputs});
  
  const { totalADistribuir, montosADistribuir, sumaImportesMontos, onAddToTable, onRemoveRow } = props;
  const { personal_id, personal_nombre, importe } = inputs;
  
  let porcentaje = (importe * 100 / totalADistribuir).toFixed(2);
  
  const setErrors = (errors) => setInputs({
    ...inputs,
    ...errors,
  });

  const onChangeInput = (field, value) => {
    setInputs({
      ...inputs,
      [field]: value,
      errors: { ...inputs.errors, [field]: undefined }
    })
  };

  const setImporte = (value) => {
    let newImporte = Math.ceil(value * 100) / 100;
    let max = (totalADistribuir * 100 - sumaImportesMontos * 100) / 100;
    onChangeInput('importe', newImporte > max ? Math.floor(max) : newImporte);
  }

  const setPorcentaje = (porcentaje) => {
    let newPorcentaje = porcentaje < 0.01 ? 0 : porcentaje;
    let newImporte = totalADistribuir * newPorcentaje / 100;
    newImporte = Math.ceil(newImporte);
    setImporte(newImporte);
  }

  const checkIsNumber = (value) => {
    if (value == null || value === '') {
      return 0;
    }

    let toReturn = value;
    if (isNaN(value)) {
      toReturn = parsearAFloat(value);
    }
    return Number(toReturn) || 0;
  }
  

  const AddToTable = () => {
    
    let errors = {};
    
    if (personal_id != null && porcentaje > 0 && ((importe + sumaImportesMontos) <= totalADistribuir)) {
      onAddToTable({
        id: null,
        personal_id,
        personal_nombre,
        grupo_id: null,
        grupo_nombre: null,
        porcentaje: porcentaje,
        importe: importe
      }, setInputs({...initialInputs}))
    } else {
      if (personal_id == null) {
        errors.personal_id = 'Seleccione un Ejecutor'
      }
      setErrors({ errors });
    }
  }

  return (
    <section className="ui-section-block ui-section-span-2">
      <h5 className="ui-section-label">Ejecutores</h5>
      <div className="ui-row-action-4">
        <div>
          <Label>Ejecutores</Label>
          {/* <ParadigmaAsyncSeeker
            nombreField={"fullname"}
            url={api.usuarios.personal.select}
            onChange={(data) => setInputs(
              {
                ...inputs, ...{ personal_id: data ? data.pk : null, personal_nombre: data ? data.fullname : '', errors: {} }
              })}
            value={personal_id}
          /> */}
          <ParadigmaAsyncSeeker2
              clearable={true}
              url={api.usuarios.personal.select}
              parameters={{
                  paginationEnabled: false,
                  sort: ['fullname']
              }}
              displayField="fullname"
              onChange={(data) => setInputs(
                {
                  ...inputs, ...{ personal_id: data ? data.id : null, personal_nombre: data ? data.fullname : '', errors: {} }
                })}
              // onChange={(e) => this.setState({personalDistribucion_id: (e) ? (e.id) : null })}
              value={personal_id}
            />
          <FormFeedback className={(inputs.errors.personal_id != undefined ? "d-block" : "")}>{inputs.errors.personal_id}</FormFeedback>
        </div>

        <div>
          <Label>%</Label>
          <Input
            type="range"
            step={0.01}
            value={trunc(porcentaje)}
            list="tickmarks"
            onChange={(e) => setPorcentaje(e.target.value)} />
            <datalist id="tickmarks">
              <option value="0" label="0%"/>
              <option value="50" label="50%"/>
              <option value="100" label="100%"/>
            </datalist> 
            <Input
            type="number"
            step={0.5}
            onFocus={e => e.target.blur()}
            value={trunc(porcentaje)}
            onChange={(e) => setPorcentaje(e.target.value)} />
            <FormFeedback className={(inputs.errors.porcentaje != undefined ? "d-block" : "")}>{inputs.errors.porcentaje}</FormFeedback>
        </div>

        <div>
          <Label>Importe</Label>
          <CurrencyInput
            allowDecimals={false}
            prefix={"$"}
            className='form-control'
            defaultValue={0}
            groupSeparator="."
            value={importe}
            onValueChange={(value, name) => setImporte(checkIsNumber(value))}
          />
          <FormFeedback className={(inputs.errors.porcentaje != undefined ? "d-block" : "")}>{inputs.errors.porcentaje}</FormFeedback>
        </div>

        <Button className={"btn btn-success"} style={{ borderRadius: "8px" }} onClick={(e) => AddToTable()}>
          <i className={"fa fa-plus"}></i>
        </Button>
      </div>

      <div className="ui-row-1">
          <Table className="ui-table table-sm">
            <thead>
              <tr>
                <th width='5%'></th>
                <th width='40%'>Ejecutor</th>
                <th width='25%'>Porcentaje</th>
                <th width='30%'>Importe</th>
              </tr>
            </thead>
            <tbody>
              {montosADistribuir.filter((e) => e.personal_id != null).map((data, i) =>
                <tr className="bg-light" key={`static${i}`}>
                  <td width='5%'> {data.disabled ? '' : <Button className="btn-round btn-small btn-danger mr-1" onClick={(e) => onRemoveRow(data.i)}><i className="fa fa-times"></i></Button>}</td>
                  <td width='40%'>{(data.grupo_id == null ? (data.personal_nombre) : (data.grupo_nombre))}</td>
                  <td width='25%' className={'text-right'}>
                    {trunc(data.porcentaje, 2)}
                  </td>
                  <td width='30%' className={'text-right'}>
                    {data.monto}
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan="3" className="col-1 text-right pr-4 font-weight-bold">Subtotal Ejecutores</th>
                <th colSpan="1" className="col-1 text-right font-weight-bold">
                  {'$ ' + formatCurrency(trunc(montosADistribuir.filter((e) => e.personal_id != null).reduce(redImportes, 0), 2))}
                </th>
              </tr>
            </tfoot>
          </Table>
      </div>
    </section>
  );
}

export default TableEjecutores;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/ImputarModal/Tables/TableEjecutores.js